import api from '@pray/shared/utils/api';

import type { WorkflowVersionsResponse } from './data/response';

type ListVersionsParams = {
  artistId: string;
  workflowId: string;
};

async function listVersions({ artistId, workflowId }: ListVersionsParams) {
  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}/versions`;

  const response = await api.executeGetRequest<WorkflowVersionsResponse>(url);

  if (!response || !response.data) {
    throw new Error('Failed to fetch workflow versions');
  }

  return response.data;
}

export default listVersions;
export { listVersions };
